<template lang="">
<div class="mt-8 responsive-push-web__logs">
    <v-card class="filter--container d-flex">
        <span class="d-flex flex-row input">
					<input v-model="s_email" type="text" placeholder="E-mail" style="width: 100%">
					<img class="imgResponsive" style="width:20px" src="../../../../static/images/email.svg">
        </span>
        <span class="d-flex flex-row input">
					<input v-model="s_messageFilter" type="text" placeholder="Mensagem" style="width: 100%">
					<img class="imgResponsive" style="width:20px" src="../../../../static/images/message.svg">
        </span>
        <date-picker v-model="s_from" class="input" format="DD/MM/YYYY" placeholder="De" input-class="border" style="padding-left: 2px !important;">
        </date-picker>
        <date-picker v-model="s_to" class="input" format="DD/MM/YYYY" placeholder="Até" input-class="border" style="padding-left: 2px !important;">
        </date-picker>

        <div class="button-wrapper d-flex justify-space-between">
					<button @click="filter" class="mr-5" :disabled="!disabled">
						<clip-loader v-if="loading" :loading="loading" color="var(--white)" size="22px" />
						<div v-if="!loading" class="button-wrapper--text">
							<img src="../../../../static/images/search.svg">
							Buscar
						</div>
					</button>

					<button @click="clearForm" style="background: var(--white); border: 1px solid grey; color: var(--dark-grey)">
						<clip-loader v-if="loadingClear" :loading="loadingClear" color="var(--black)" size="22px" />
						<div v-if="!loadingClear" class="button-wrapper--text">
							<img src="../../../../static/images/load.svg">
							Limpar
						</div>
					</button>
        </div>
    </v-card>

    <h4 style="fontSize: 20px" class="mt-12">Logs</h4>

    <div v-if="!loadingData">
        <v-expansion-panels class="mt-5">
            <v-expansion-panel v-for="(item, index) in items" :key="index" @click="onExpansionPanelClick" class="mt-2 d-flex align-center flex-column rounded-lg" height="59" id="expansion-item">
                <v-expansion-panel-header hide-actions :disabled="!canOpen" class="d-flex align-center" style="padding: 10px 2px; position: initial; cursor: auto">
										<span class="rounded borderLeft" style=""></span>
										<div class="d-flex align-center justify-space-between">
											<div class="responsiveItemName">
												<span class="mr-9 font-weight-black widthResponsive">{{item.email}}</span>
											</div>
											<div class="d-flex align-center justify-space-between">
												<span class="font-weight-black">Data:</span><span class="mr-9 ml-1">{{formatDataTimestamp(item.date)}}</span>
												<span class="font-weight-black">Horas:</span><span class="mr-9 ml-1">{{formatHourTimestamp(item.date)}}</span>
												<div class="buttons_action">
													<v-tooltip top>
														<template v-slot:activator="{ on, attrs }">
															<button
																style="
																	border: 2px solid var(--grey-day-020);
																	height: 40px;
																	width: 40px;
																"
																class="b-4 mr-6 d-flex justify-center align-center"
																@click="getLogsDetails(item.id)"
																v-bind="attrs"
																v-on="on"
															>
																<img src="../../../../static/images/warning.svg"/>
															</button>
														</template>
														<span>Clique aqui para mais detalhes</span>
													</v-tooltip>
												</div>
											</div>
										</div>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="ml-16 responsive-push-web__logs">
									<div class="d-flex flex-column">
										<span class="font-weight-black mt-4">Arquivo</span>
										<span>{{idUser.csvName}}</span>
									</div>
									<div class="d-flex flex-column">
										<span class="font-weight-black mt-4">Data de criação</span>
										<span>{{formatDate(item.dateAdded)}}</span>
									</div>
									<div class="d-flex flex-column responsive-push-web__logs__message">
										<span class="font-weight-black mt-4">Mensagem: </span>
										<span class="responsive-push-web__logs__message__span">{{idUser.messageContent}}</span>
									</div>
									<div v-if="idUser.urlRedirect" class="d-flex flex-row align-center mt-4">
										<span class="font-weight-black">Url do Redirect:</span>
										<span class="ml-2" style="width: 990px; word-break:break-word">{{idUser.urlRedirect}}</span>
									</div>
									<div class="d-flex flex-column align-start" v-if="idUser.button1Url">
										<span class="font-weight-black mt-4 mb-6">Botões:</span>
										<v-row>
											<v-col>
												<span class="btnRed mb-5">{{idUser.button1Text}}</span>
												<v-col class="d-flex flex-column mt-4">
													<span class="font-weight-black">Botão 1</span>
													<span style="width:300px">Url: {{idUser.button1Url}}</span>
												</v-col>
											</v-col>
											<v-col v-if="!!idUser.button2Text">
												<span class="btnRed">{{idUser.button2Text}}</span>
												<v-col class="d-flex flex-column mt-4">
													<span class="font-weight-black">Botão 2</span>
													<span>Url: {{idUser.button2Url}}</span>
												</v-col>
											</v-col>
										</v-row>
									</div>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
    </div>

    <div v-if="loadingData" class="mt-5 d-flex justify-center align-center rounded" style="background: var(--white); width: auto; height: 200px">
      <span>Dados não encontrados!</span>
    </div>
    
    <!-- Pagination -->
    <v-card class="mt-8 mb-1" v-if="!loadingData">
			<div v-if="!loading" class="list-footer">
				<span></span>
				<v-pagination
					v-model="page"
					:length="numberPages"
					color="#F0F1F3"
					:total-visible="7"
					@input="nextPage">
				</v-pagination>
				<div class="goToPage">
					<span class="goToPage--text">
							Ir para página
					</span>
					<label>
						<input v-model="goToPage" type="text">
						<button @click="goToPageRequest" :disabled="disabledGoTo">
							<div class="button-wrapper--text">
								<i class="iconStyle icon-arrow-right d-flex justify-center align-center"></i>
							</div>
						</button>
						<span :class="showGoToPageHelpText ? '--show-helptext' : '--hide-helptext'" class="goToPage--helptext">
							A página deve estar entre 1 e {{numberPages}}
						</span>
					</label>
				</div>
			</div>
    </v-card>

    <div style="height: 5px"></div>

    <!-- Drwaer edit -->
    <v-navigation-drawer v-model="drawer" fixed overlay temporary right width="890" height="100vh" style="background: var(--grey-day-010)">
        <EditPush v-on:close="drawer = false" />
    </v-navigation-drawer>
</div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/pt-br";
import {
    mapActions,
    mapMutations,
    mapState
} from "vuex";
import ClipLoader from "vue-spinner/src/ClipLoader.vue";
import moment from 'moment'

import VueCookies from 'vue-cookies'
import EditPush from "./EditPush.vue";
import date from '../../../mixins/date'

export default {
    mixins: [date],
    components: {
        DatePicker,
        ClipLoader,
        EditPush,
    },
    data() {
        return {
            disabled: false,
            loading: false,
            page: 1,
            goToPage: 1,
            disabledGoTo: false,
            showGoToPageHelpText: false,
            s_email: "",
            s_messageFilter: "",
            s_from: "",
            s_to: "",
            search_message: "",
            drawer: false,
            service: "",
            date: "",
            loadingData: true,
						canOpen: false,
        };
    },
    async created() {
        await this.filter();
				this.getDetailsPushWeb()
    },
    computed: {
        ...mapState("PushWebLogs", {
            items: "items",
            services: "services",
            totalElements: "totalElements",
            currentPage: "current_page",
            loadingClear: "loadingClear",
            totalPages: "totalPages",
						idUser: 'idUser'
        }),
        servicesList() {
            const serviceList = this.services ? this.services : [];
            return serviceList.map((service) => ({
                value: service.id,
                label: service.serviceName,
            }));
        },
				numberPages () {
					return this.totalPages
				},
    },
    methods: {
        ...mapActions("PushWebLogs", [
            "allPushWebLogs",
            "getService",
            "filterLogstestes",
						"getDetailsPushWeb"
        ]),
        ...mapMutations("PushWebLogs", {
            setCurrentPage: "SET_CURRENT_PAGE",
            setLogsToEdit: "SET_LOGS_TO_EDIT",
            setSeachEmailFilter: "SET_SEARCH_EMAIL_FILTER",
            setSeachMessageFilter: "SET_SEARCH_MESSAGE_FILTER",
            setloadingClear: "LOADING_CLEAR",
            setPageSize: "SET_PAGE_SIZE",
        }),
				onExpansionPanelClick(event) {
					if(event.currentTarget.classList.contains('v-expansion-panel-header--active')) {
						this.canOpen = false
					}
				},
				formatDataTimestamp (data) {
					let timestamp = data
					const date = new Date(timestamp)
					return moment(date).format('DD/MM/YYYY')
				},
				formatHourTimestamp (data) {
					let timestamp = data
					const date = new Date(timestamp)
					return moment(date).format('HH:mm')
				},
				async nextPage (e) {
					this.goToPage = this.page
					this.setCurrentPage(e - 1)
					await this.filter()
				},
        getSearch() {
					let search = "";
					if (this.s_email) search += `&emailFilter=${this.s_email}`;
					if (this.s_messageFilter) search += `&messageFilter=${this.s_messageFilter}`;

					if (this.s_from) search += `&firstDate=${moment(this.s_from).format('YYYY-MM-DD')}`;
					if (this.s_to) search += `&lastDate=${moment(this.s_to).format('YYYY-MM-DD')}`;
					return search
        },
        async filter() {
            this.loadingData = true
            let search = this.getSearch()
            const token = VueCookies.get('jwt-login')
            try {
							await this.allPushWebLogs({
								token,
								search,
							});
							this.loadingData = false;
            } catch (error) {
                console.log(error)
            }
        },
        async goToPageRequest() {
					this.loadingData = true;
					this.setCurrentPage(this.goToPage - 1);
					this.page = Number(this.goToPage)
					await this.filter();
					this.loadingData = false;
        },
				async getLogsDetails (id) {
					this.canOpen = true
					const token = VueCookies.get('jwt-login')
					try {
						await this.getDetailsPushWeb([
							id, token])
					this.canOpen = false
					}
					catch (error) {
						this.toaster(
							error.message,
							'var(--red)',
							true
						)
					}
				},
        async clearForm() {
            this.loadingData = true;
            this.s_email = "";
            this.s_messageFilter = "";
            this.s_from = "";
            this.s_to = "";

            this.setCurrentPage(0);
            this.goToPage = 1;
						this.page = 1

            const token = VueCookies.get('jwt-login')
            const search = ''

            await this.allPushWebLogs({
                token,
								search
            });
            this.loadingData = false;
        },
        setEditPush(item) {
            this.setLogsToEdit(item);
            this.drawer = !this.drawer;
        },
    },
    watch: {
			goToPage() {
				if (this.goToPage < 1 || this.goToPage > this.totalPages) {
					this.showGoToPageHelpText = true;
					this.disabledGoTo = true;
				} else {
					this.showGoToPageHelpText = false;
					this.disabledGoTo = false;
				}
			},
			"s_email"() {
				this.s_email !== null
					? this.disabled = true
					: this.disabled = false
			},
			"s_messageFilter"() {
				this.s_messageFilter !== ''
					? this.disabled = true
					: this.disabled = false
			},
			's_from'() {
				this.s_from !== null
					? this.disabled = true
					: this.disabled = false
			},
			's_to'() {
				this.s_to !== null
					? this.disabled = true
					: this.disabled = false
			},
    },
};
</script>

<style lang="scss" scoped>
.input {
    border-radius: 4px !important;
}

.btnRed {
	min-width: 130px;
	background: var(--red);
	color: var(--white);
	padding: 17px;
	margin-top: 20px;
	margin-bottom: 20px;
	border-radius: 4px;
}

// responsive note
.responsive-push-web__logs {
    width: 1224px;
    max-width: 100%;

		.responsive-push-web__logs__message {
			.responsive-push-web__logs__message__span {
				width: 1140px;
			}
		}

    .mx-datepicker {
        display: flex;
        padding-left: 10px !important;
        align-items: center;
    }

    .button--duplicate {
        text-align: -webkit-right;
        margin-right: 0px;
    }
}

.mx-input {
    outline: none !important;
    border: none !important;
    display: flex;
    height: 44px;
    border: none !important;
    box-shadow: 0 !important;
}

.vs__selected-options {
    width: 250px;
    padding-right: 20px;
}

.v-expansion-panel-header {
    padding: 7px 10px 7px 3px;
}

.mx-input-wrapper {
    margin-top: -8px;
}
.responsive-push-web__logs {
.filter--container {
    background: var(--white);
    border-radius: 4px;
    margin-bottom: 3.125rem;
    padding: 1.375rem;
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    height: 88px;

    .input {
        border: 2px solid var(--grey-day-030);
        height: 48px;
        padding: 7px;
				justify-content: space-between;
        margin-right: 20px;
        border-radius: 4px;
        padding-left: 0;
        border-radius: 4px !important;
        font-family: "DM Sans Regular", sans-serif;

        input {
            padding-left: 10px;
        }

        img {
            opacity: 0.5;
        }
    }

    label:focus-within {
        border: 2px solid var(--grey);
    }

    .button-wrapper {
        display: flex;
        justify-content: flex-end;
        justify-self: flex-start;

        &--text {
            display: flex;
            align-items: center;
        }

        button {
            background: var(--dark-red);
            border: none;
            border-radius: 4px;
            color: var(--white);
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
            font-family: var(--dm-sans-medium);
            font-size: 1rem;
            padding: 0.875rem;
            min-height: 48px;
            width: 130px;

            img {
                margin-right: 0.875rem;
            }
        }

        button:disabled {
            background: #dddddd;
            cursor: not-allowed;
        }
    }
	}
}

.b-4 {
    border: 2px solid var(--grey-day-030);
    border-radius: 4px;
}

.h-48 {
    height: 48px;
}

.vs__dropdown-toggle {
    border: none !important;
}

.vs__search {
    display: flex;
    align-items: center;
    padding: 7px;
}

// Pagination

.list-footer {
    background: var(--white);
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.75rem 2.625rem;
    margin: 80px 0 10px 0;
    height: 64px;
}

.v-pagination__navigation,
.v-pagination__item {
    border: none;
    box-shadow: none;
}

.goToPage {
    &--text {
        font-size: 14px;
        font-family: var(--dm-sans-regular);
        color: var(--dark-grey);
        margin-right: 20px;
    }

    label {
        border: 2px solid var(--grey-day-030);
        background: var(--white);
        border-radius: 4px;
        box-sizing: border-box;
        max-width: 84px;
        width: 80px;
        padding: 10px;
        position: relative;

        input {
            width: 54px;
            font-size: 1rem;
            color: var(--grey);
            font-family: var(--dm-sans-regular);
        }

        button {
            position: absolute;
            border-radius: 50%;
            border: none;
            padding: 0;
            top: 11px;
            right: 8px;
            background: var(--grey);
            cursor: pointer;

            i {
                color: var(--white);
                font-size: 1.25rem;
            }
        }

        button:disabled {
            opacity: 0.6;
            cursor: not-allowed;
        }
    }

    &--helptext {
        font-family: var(--dm-sans-regular);
        position: absolute;
        font-size: 12px;
        width: 120px;
        text-align: center;
        top: -55px;
        left: -24px;
        background: var(--dark-red);
        padding: 8px;
        color: var(--light-grey);
        border-radius: 4px;
    }

    .--hide-helptext {
        display: none;
    }

    .--show-helptext {
        display: block;
    }
}

.iconStyle {
    width: 20px;
    height: 20px;
    background: transparent;
}

.v-application .widthResponsive {
    width: 10%;
    margin-left: 50px;
}

.borderLeft {
    height: 50px;
    max-width: 3px !important;
    width: 13px;
    background-color: var(--blue);
    margin: 0 3px;
    position: absolute;
}

.v-expansion-panel--active .borderLeft {
    height: initial;
    // max-width: 3px !important;
    transition: 0.3s;
    width: 4px;
    background-color: var(--blue);
    margin: 0px 3px;
    position: absolute;
    top: 9px;
    bottom: 9px;
}

@media screen and (max-width: 1377px) {
    .responsive-push-web__logs {
				.responsive-push-web__logs__message {
					.responsive-push-web__logs__message__span {
						width: 730px;
					}
				}
		
        width: 830px;
    }

    .responsive {
        width: 158px;
    }

    .widthResponsive {
        width: 200px;
        margin-top: 0;
    }

    .imgResponsive {
        display: none;
    }

    .responsive-push-web__logs {
        width: 830px;

        .filter--container {
            height: initial;
            display: grid !important;
            grid-template-columns: 1fr 1fr;
            gap: 8px;

            &.d-flex {
                display: grid !important;
                grid-template-columns: 1fr 1fr;
                gap: 8px;
            }

            .button-wrapper {
                grid-row: 4;
                grid-column: 1 / -1;
            }

            .input {
                width: 100%;

                &.mx-datepicker {
                    input {
                        background: black;
                        width: 100%;
                    }
                }

                &:nth-child(1) {
                    grid-row: 1;
                    grid-column: 1 / -1;
                }

                &:nth-child(2) {
                    grid-row: 2;
                    grid-column: 1 / -1;
                }

                &:nth-child(3) {
                    grid-row: 3;
                }

                &:nth-child(4) {
                    grid-row: 3;
                }

                &.mx-datepicker:nth-child(3) {
                    // margin-bottom: -48px;
                    // width: 48%;
                }
            }

            .mx-datepicker:nth-child(4) {
                // grid-column: 2;
                // grid-row: 3;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Contents/ScheduleMessage/LogsPushWeb.vue